<template>
  <dialog-layout>

    <!--Confirm Email After Sign Up-->
    <template v-if="stage === 'CONFIRM_EMAIL'">
      <confirm-email :email="email" :sendCode="true" @confirm="handleEmailConfirmed"></confirm-email>
    </template>

    <!--Enter MFA Code-->
    <template v-else-if="stage === 'RESET_PASSWORD'">
      <force-reset-password @password="handleResetPasswordSuccess" :submit="resetPasswordSubmit"></force-reset-password>
    </template>

    <!--Login Form-->
    <template v-else>
      <h1 class="title is-h1">Login</h1>

      <div class="notification is-danger" v-if="errorMessage">
        {{ errorMessage }}
      </div>

      <form @submit.prevent="handleLogin">
        <b-field label="Email Address">
          <b-input type="email" :required="true" v-model.trim="email"></b-input>
        </b-field>
        <b-field label="Password">
          <b-input type="password" :required="true" v-model.trim="password"></b-input>
        </b-field>
        <button class="button is-primary" :disabled="loginLoading">
          Login
        </button>
        <p>
          <router-link :to="{ name: 'login.forgotPassword' }">Forgot your password?</router-link>
        </p>
      </form>
    </template>

  </dialog-layout>
</template>

<script>
import DialogLayout from '../layouts/DialogLayout.vue'
import ConfirmEmail from '../components/auth/ConfirmEmail'
import ForceResetPassword from '../components/auth/ForceResetPassword'

export default {
  components: {
    DialogLayout,
    ConfirmEmail,
    ForceResetPassword
  },
  data () {
    return {
      email: '',
      password: '',
      stage: null,

      errorMessage: null,
      loginLoading: null,

      resetPsaswordSubmit: null,
      mfaCodeSubit: null
    }
  },
  methods: {
    // Submit Login
    handleLogin () {
      // reset the loading and error indicators
      this.loginLoading = true

      // extract the credentials
      const { email, password } = this

      // process the login from the store action
      this.$cognito.login(email, password, null, this.newPasswordRequiredCallback)
        .then(() => {
          // redirect to home
          this.$router.push({ name: 'home' })
        })
        .catch((e) => {
          // if the error is because the email address hasn't been confirmed yet, then redirect to the screen for confirming the code
          if (e.code === 'UserNotConfirmedException') {
            this.stage = 'CONFIRM_EMAIL'
          } else {
            // show the error based on stage
            this.errorMessage = e.message
          }
        })
        .then(() => {
          this.loginLoading = false
        })
    },

    // after email address has been confirmed via code
    handleEmailConfirmed () {
      // re-attempt the login
      this.handleLogin()
    },

    // callback to get the new password if a password reset is required for Cognito
    newPasswordRequiredCallback (userAttributes, requiredAttributes, done) {
      // set the "done" callback to the scope so the child component can access it
      this.resetPasswordSubmit = done
      // set the stage
      this.stage = 'RESET_PASSWORD'
    },
    // handle the password being successfully reset
    handleResetPasswordSuccess (newPassword) {
      // set the new password to the scope
      this.password = newPassword
      // unset the stage
      if (this.stage === 'RESET_PASSWORD') {
        this.stage = null
      }
    }
  }
}
</script>
